import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import myImg from "../../Assets/avatar.svg";
import Tilt from "react-parallax-tilt";

function Home2() {
  return (
    <Container fluid className="home-about-section" id="about">
      <Container>
        <Row>
          <Col md={8} className="home-about-description">
            <h1 style={{ fontSize: "2.6em" }}>
              LET ME <span className="purple"> INTRODUCE </span> MYSELF
            </h1>
            <p className="home-about-body">
              I’m a <span className="purple">Senior Quality Engineer</span> who
              focuses on designing and owning quality systems for modern SaaS
              products. My work centers on ensuring products are{" "}
              <span className="purple">
                reliable, scalable, and safe to change
              </span>
              .
              <br />
              <br />
              I specialize in building{" "}
              <span className="purple">
                deterministic test automation frameworks
              </span>{" "}
              across web and mobile, and embedding quality early through a{" "}
              <span className="purple">shift-left approach</span>.
              <br />
              <br />
              I work primarily with
              <i>
                <b className="purple">
                  {" "}
                  TypeScript, JavaScript, Playwright, Appium, and WebdriverIO{" "}
                </b>
              </i>
              , and I collaborate closely with product and engineering teams to
              ensure quality is built in from design through release.
              <br />
              <br />
              My areas of focus include
              <i>
                <b className="purple">
                  {" "}
                  end-to-end automation architecture, API-driven testing,
                  CI/CD reliability, and payments-critical flows{" "}
                </b>
              </i>
              .
              <br />
              <br />
              Whenever possible, I enjoy improving developer velocity by making
              automation{" "}
              <span className="purple">
                easy to write, easy to debug, and trusted in CI
              </span>
              .
            </p>
          </Col>
          <Col md={4} className="myAvtar">
            <Tilt>
              <img src={myImg} className="img-fluid" alt="avatar" />
            </Tilt>
          </Col>
        </Row>
      </Container>
    </Container>
  );
}

export default Home2;
